// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__OKjrj","title":"BackImages_title__24MX0","images":"BackImages_images__3TUAC"};